import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ServerConnectionService } from '../server-connection.service';
import { CoreModule } from '../../core.module';
import { OrderService } from './order.service';
import { PopulatedFeaturedBookAPIResponse } from '../../../types/responses';

const BASE_UPSELL_URI = '/api/upsell';
const ENDPOINT_FETCH_UPSELL_BY_SITE_ADVERT = `${BASE_UPSELL_URI}/fetch-upsell-by-advert`;

@Injectable({
	providedIn: CoreModule,
})
export class UpsellService {
	constructor(
		private scs: ServerConnectionService,
		private os: OrderService,
	) { }

	public fetchPossibleUpsell(siteAdvertId, pubDate) {
		return this.scs.http$('GET', `${ENDPOINT_FETCH_UPSELL_BY_SITE_ADVERT}/${siteAdvertId}/${pubDate}`, null, null);
	}

	public createUpsellFeature(
		upsellId,
		featureId,
		applyingDiscount,
		paymentAmount,
		discountAmount,
		promoCode,
		purchaseSource = null,
	) {
		const data = { upsellId, featureId, applyingDiscount, paymentAmount, discountAmount, promoCode, purchaseSource };
		return new Promise((resolve, reject) => {
			this.scs.http$('POST', '/api/upsell/create-upsell-feature', null, data)
				.pipe(switchMap((result: PopulatedFeaturedBookAPIResponse) => {
					if (result.success && result.featuredBook) {
						return this.os.addItem(result.featuredBook._id, 'featuredBook', result.featuredBook);
					}
					return of(result);
				}))
				.subscribe(
					(result: any) => {
						if (result.success && result.order) {
							resolve(result.order);
						} else {
							reject(result);
						}
					},
				);
		});
	}
}
